import { openDialog } from '../../../../../react/features/base/dialog/actions';
import { IconControlSharing } from '../../../../../react/features/base/icons/svg';
import ContextMenuItem from '../../../../../react/features/base/ui/components/web/ContextMenuItem';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ControlSharingDialogList
from '../../../../components/wildix-remote-control/components/web/ControlSharingDialogList';

const ControlSharingDialogListButton = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const onClick = useCallback(
        () => {
            dispatch(openDialog(ControlSharingDialogList));
        }, []
    );

    return (
        <ContextMenuItem
            accessibilityLabel = { t('controlSharing.btnOverflowOpenDialog') }
            className = { 'controlSharingButton' }
            text = { t('controlSharing.btnOverflowOpenDialog') }
            icon = { IconControlSharing }
            onClick = { onClick }
        />
    );
};

export default ControlSharingDialogListButton;
